import { useState } from 'react';
import { RequestProvider } from '@shootsta/common-react';
import HalloweenPromoModalComponent from '../components/HalloweenPromoModal';
import paymentCheckoutApi from '../../TopupCreditsModal/api/paymentCheckout';
import { TopupPromo } from '../../TopupCreditsModal/utils/topupPromo';

type Props = {
  visible: boolean;
  promo: TopupPromo;
  organisationId: string;
  onClose: () => void;
};

const CHECKOUT_ERROR = "We couldn't open checkout. Please try again.";

type ClaimProps = Omit<Props, 'organisationId'> & {
  paymentCheckout: (args: {
    quantity: number;
    originUrl: string;
  }) => Promise<{ data: any; error: any }>;
};

function HalloweenPromoClaim({
  visible,
  promo,
  onClose,
  paymentCheckout
}: ClaimProps) {
  const [claiming, setClaiming] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Same checkout as Top up Credits, for exactly the promo's buy quantity.
  // The backend adds the free credits from the same flag.
  const claim = async () => {
    setClaiming(true);
    setError(null);
    try {
      const { data, error: checkoutError } = await paymentCheckout({
        quantity: promo.buyQuantity,
        originUrl: window.location.href
      });
      const checkoutUrl = data?.paymentCheckout?.checkoutUrl;

      if (checkoutError || !checkoutUrl) {
        setError(CHECKOUT_ERROR);
        setClaiming(false);
        return;
      }

      // Stays in the claiming state while the browser leaves for Stripe.
      window.location.href = checkoutUrl;
    } catch {
      setError(CHECKOUT_ERROR);
      setClaiming(false);
    }
  };

  return (
    <HalloweenPromoModalComponent
      visible={visible}
      promo={promo}
      claiming={claiming}
      error={error}
      onClaim={claim}
      onClose={onClose}
    />
  );
}

export default function HalloweenPromoModal({
  organisationId,
  ...props
}: Props) {
  return (
    <RequestProvider
      requests={{ paymentCheckout: paymentCheckoutApi(organisationId) }}
    >
      {(api: any) => (
        <HalloweenPromoClaim {...props} paymentCheckout={api.paymentCheckout} />
      )}
    </RequestProvider>
  );
}
